import React, {useCallback} from "react";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../react-hooks/use-services.hook";
import {DialogButtonClickHandleResultEnum} from "../../../services/dialog/dialog.service.interface";
import {FlexContainerBox} from "../../../themes/architecture/css-helpers/flex";
import {AddFundsDialogComponent} from "../../regulation-specific/italy/add-funds/add-funds-dialog.component";

export const AddFundsDialogShowcaseComponent: React.FC = () => {
    const services = useServices();
    const _openFundsDialog = useCallback(() => {
        services.dialog.showModal(dialogHandler => (<AddFundsDialogComponent
            dialogHandler={dialogHandler}
            onAddFunds={(number) => {
                console.log(number)
            }}
            maxLimitInCents={() => 45678}
            minLimitInCents={() => 100}
        />), {
            title: services.translation.translate('GAME_LIMIT_TITLE'),
            forceCentralization: true,
            mobileCenterHeader: true,
            disableFullscreenMobile: true,
            onClosedByXButton: () => {},
            isHighPriority: true,
        });
    }, [services.dialog, services.translation]);

    const _openLimitsReachedDialog = useCallback(() => {
        services.dialog.showSimpleTextModal({
            iconSvg: services.theme.currentTheme.icons.warningSignIcon,
            title: services.translation.translate("ADD_FUNDS_BLOCKED_TITLE"),
            text: services.translation.translate("ADD_FUNDS_BLOCKED_MESSAGE"),
            buttons: [
                {
                    text: services.translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async () => {
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue
                    }
                }
            ]
        });
    }, [services.dialog, services.theme, services.translation]);

    return (<FlexContainerBox>
        <Button preset={"primary"} onClick={_openFundsDialog}>Italy Add Funds Popup</Button>
        <Button preset={"secondary"} onClick={_openLimitsReachedDialog}>Italy Limit Reached Popup</Button>
    </FlexContainerBox>);
}